export default function pageIndex(metaTags) {
    switch (metaTags?.pageIndex) {
        case 'IndexFollow':
            return 'index, follow';
        case 'NoIndexFollow':
            return 'noindex, follow';
        case 'IndexNoFollow':
            return 'index, nofollow';
        case 'NoIndexNoFollow':
            return 'noindex, nofollow';
        default:
            const noIndexNoFollowString = metaTags?.noIndexNoFollowString || metaTags?.robots;
            const noIndexNoFollowRequired =
                metaTags?.noIndexNoFollowRequired || metaTags?.noIndexNoFollow;
            if (noIndexNoFollowString) {
                return noIndexNoFollowString.toLowerCase();
            }
            if (noIndexNoFollowRequired) {
                return 'noindex, nofollow';
            }
    }
}
